import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDfl9hg01BRjUXuMn0e1xwJJs9zyXPmalY",
  authDomain: "alfred-access-ce3ef.firebaseapp.com",
  projectId: "alfred-access-ce3ef",
  storageBucket: "alfred-access-ce3ef.appspot.com",
  messagingSenderId: "401994068101",
  appId: "1:401994068101:web:eef2b6547c3d247e5ab9ec"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
